import React, { useState } from "react";
import { useQuery } from "react-query";
import { useSnackbar } from "notistack";
import classNames from "classnames";

import { Column, Row } from "components/Layout";
import IntervalBar from "components/IntervalBar/IntervalBar";
import WeatherWidget from "components/WeatherWidget";
import Charts from "./ChartsV2";
import Tables from "./TablesV2";
import styles from "./_charts.module.scss";

import { getTodayData, getWeeklyData, getMonthlyData, getCustomData, useGetDevices } from "service/Agrismart2Service";
import { getErrorMessage } from "service/Client";


export default function IntervalPage({ type, display }) {

	let [device, setDevice] = useState();
	let [interval, setInterval] = useState("daily");
	let [startDate, setStartDate] = useState();
	let [endDate, setEndDate] = useState();
	const { enqueueSnackbar } = useSnackbar();
	let { devices } = useGetDevices()

	function showError(e) {
		enqueueSnackbar(getErrorMessage(e), { variant: "error" });
	}

	let { data } = useQuery(['data', { device, interval, startDate, endDate }], () => {
		let promise
		
		if (interval === "daily") {
			promise = getTodayData(device);
		} else if (interval === "weekly") {
			promise = getWeeklyData(device);
		} else if (interval === "monthly") {
			promise = getMonthlyData(device);
		} else if (startDate !== null && endDate !== null) {
			promise = getCustomData(device, startDate.format("YYYY-MM-DD"), endDate.format("YYYY-MM-DD"));
		}
		return promise
	}, {
		enabled: !!device && (interval !== 'custom' || (!!startDate && !!endDate)),
		initialData: [],
		onError: showError,
		refetchInterval: (interval === 'daily') ? 10000 : false,
	})

	if (devices.length === 0) return <div />
	if (!device) {
		setDevice(devices[0].device)
	}

	let deviceObj = devices.find(d => d.device === device);

	return (
		<div className={classNames("animated", "fadeIn", styles.box)}>
			<IntervalBar
				devices={devices}
				device={device}
				setDevice={setDevice}
				interval={interval}
				setInterval={setInterval}
				startDate={startDate}
				setStartDate={setStartDate}
				endDate={endDate}
				setEndDate={setEndDate}
			/>

			{
				display === "charts" &&
					<>
						<Charts data={data} device={deviceObj} type={type}/>
						{deviceObj && <Row>
							<Column>
								<div className={styles.weatherWidgetContainer}>
									<WeatherWidget
										lat={deviceObj.lat}
										lng={deviceObj.lng}
										location={device}
										type="forecast"
									/>
								</div>
							</Column>
						</Row>}
					</>
			}
			{
				display === "table" && <Tables data={data} device={deviceObj} />
			}
		</div>
	);
}
